module.exports = __webpack_public_path__ + "static/media/mock1.42bb7ad6.svg";